import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import {
  changeCustomerInfo,
  renewCorporateRsdn,
} from '@store/actions/customerAction';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, {
  Autoplay,
  Pagination,
  Navigation,
  Controller,
} from 'swiper';
import slideOne from '@assets/images/img/img-home-woman-yellow@2x.png';
import slideTwo from '@assets/images/img/img-home-man-red@2x.png';
import slideThree from '@assets/images/img/img-home-man-green@2x.png';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import SatButton from '@components/common/satUI/SatButton';
import SatModal from '@components/common/satUI/SatModal';
import { RegisterAgreeSmsSendPopupArea } from '@container/customer';

SwiperCore.use({ Autoplay, Pagination, Navigation, Controller });

const stateSelector = createSelector(
  state => state.router,
  state => state.commonReducer,
  state => state.customerReducer,
  (router, common, customer) => ({
    location: router.location,
    inProgress: common.inProgress ?? [],
    errorObj: customer.errorObj,
    customerInfo: customer.customerInfo,
  }),
);

// NOTE: CustomerBottomArea 겸용 / 추후 필요 시 Route(/customer)와 함께 Customer 용으로 분리
const HomeBottomArea = () => {
  const dispatch = useDispatch();

  const { alert, confirm } = $hooks.useModal();
  const { location, inProgress, customerInfo, errorObj } =
    useSelector(stateSelector);
  const [isSmsSendPopupVisible, setIsSmsSendPopupVisible] = useState(false);
  const { alertAndShowJobDriverPopup, updateCustomerJobDriver } =
    $hooks.useCustomer();

  const checkValidCustomerInfo = () => {
    const isCorporate = $utils.checkCorporate(customerInfo);
    const { email, foreigner, corporation, address, postPlace } = errorObj;
    const isCustomerError = errorObj
      ? Object.values(errorObj).some(isError => isError)
      : false;

    if (email) {
      alert({ message: '이메일 정보를 확인해주세요.' });
    } else if (foreigner) {
      alert({ message: '외국 국적인 경우 영문명은 필수입니다.' });
    } else if (corporation) {
      alert({ message: '법인 정보를 확인해주세요.' });
    } else if (address) {
      alert({ message: '주소 정보를 확인해주세요.' });
    } else if (postPlace) {
      alert({ message: '우편물 수령처를 선택해주세요.' });
    } else if (isCorporate) {
      const isValidRsdn = $utils.checkValidRsdn(customerInfo);
      if (!isValidRsdn) {
        alert({ message: '사업자등록번호를 확인해주세요.' });
        return false;
      }
    }

    return !isCustomerError;
  };

  const handleSaveCustomer = async () => {
    // 직업정보 확인
    const isValidJobDriver = $utils.checkValidJobDriver(customerInfo);
    if (!isValidJobDriver) {
      return alertAndShowJobDriverPopup(customerInfo, {
        onOk: updateCustomerJobDriver,
      });
    }

    const isValidCustomerInfo = checkValidCustomerInfo();
    if (!isValidCustomerInfo) return;

    // 법인 고객일 경우 정보 확인
    const isCorporate = $utils.checkCorporate(customerInfo);
    if (isCorporate) {
      const isCorporateByRegNo = $utils.checkCorporateByRegNo(customerInfo);
      if (!isCorporateByRegNo) {
        const isConfirm = await new Promise(resolve =>
          confirm({
            message:
              `해당 고객은 법인등록번호로 등록된 고객으로 가입설계를 진행하려면 ` +
              `'사업자등록번호'로 고객정보 신규 등록이 필요합니다. ` +
              `사업자등록번호로 신규 법인고객등록을 하시겠습니까?`,
            onClose: resolve,
          }),
        );

        if (isConfirm) {
          await new Promise(resolve =>
            alert({
              message:
                `구)푸르덴셜생명 법인번호 기계약의 경우 사업자번호 변경이 필요합니다. ` +
                `신계약 진행시 함께 발행되는 '보험 계약내용 변경 정정신청서' 상에 ` +
                `대표증번, 변경전 법인번호, 변경 후 사업자번호를 기재 후 인감날인하여 접수 부탁드립니다.`,
              onClose: resolve,
            }),
          );

          return dispatch(renewCorporateRsdn({ customerInfo }));
        }
      }
    }

    dispatch(changeCustomerInfo());
  };

  return (
    <>
      {location.pathname === '/home/customerInfo' && (
        <div className="con-bottom bg-gray box-shadow">
          <div className="btn-area">
            <div className="box-btns-center">
              <SatButton
                styleClass="btn-s blue btn-wide"
                label="저장"
                disabled={!inProgress.includes('/home')}
                onClick={handleSaveCustomer}
              />
            </div>
          </div>
        </div>
      )}

      {location.pathname === '/home/searchCustomer' && (
        <>
          <div className="con-bottom">
            <div className="btn-area">
              <div className="box-btns-right">
                <SatButton
                  styleClass="btn-s b-blue3"
                  iconStyleClass="ico ico-sms"
                  label={'가입설계동의 SMS 발송'}
                  onClick={() => setIsSmsSendPopupVisible(true)}
                />
              </div>
            </div>
          </div>
          <section className="main-banner">
            <Swiper
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              centeredSlides={true}
              className="mySwiper"
              // controller={{ control: controlledSwiper2 }}
              modules={[Controller, Autoplay, Pagination]}
              navigation={false}
              pagination={{
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets',
              }}
              spaceBetween={0}
            >
              <SwiperSlide>
                <img alt={'설정기능 소개'} src={slideOne} />
              </SwiperSlide>
              <SwiperSlide>
                <img alt={'청약목록에서 한번에'} src={slideTwo} />
              </SwiperSlide>
              <SwiperSlide>
                <img alt={'sat의 편리한 프로세스'} src={slideThree} />
              </SwiperSlide>
              <div className="pagination-container">
                <div className="swiper-pagination" />
              </div>
              {/* <div className="swiper-pagination2" /> */}
            </Swiper>

            {/* <Swiper
            className="mySwiper2"
            controller={{ control: controlledSwiper }}
            modules={[Controller, Pagination]}
            pagination={{
              el: '.swiper-pagination2',
              type: 'fraction',
            }}
            onSwiper={(data) => {setControlledSwiper2(data)}}
          >
            <SwiperSlide />
            <SwiperSlide />
            <SwiperSlide />
          </Swiper> */}
          </section>
        </>
      )}

      <SatModal
        visible={isSmsSendPopupVisible}
        setVisible={() => {
          setIsSmsSendPopupVisible(false);
        }}
        type="confirm"
      >
        <>
          <RegisterAgreeSmsSendPopupArea
            setIsSmsSendPopupVisible={setIsSmsSendPopupVisible}
          />
        </>
      </SatModal>
    </>
  );
};

export default HomeBottomArea;
